import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeFrCh from '@angular/common/locales/fr-CH';
import localeFrChExtra from '@angular/common/locales/extra/fr-CH';
import localeItCh from '@angular/common/locales/it-CH';
import localeItChExtra from '@angular/common/locales/extra/it-CH';
import { Locale } from 'date-fns';
import { de, fr, it } from 'date-fns/locale';
import { LanguageCode } from '../types/rest-api';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);
registerLocaleData(localeFrCh, 'fr-CH', localeFrChExtra);
registerLocaleData(localeItCh, 'it-CH', localeItChExtra);

/**
 * Angular locale per app language (DatePipe, numbers). German stays de-DE so
 * existing number and price formats do not change.
 */
export const LOCALE_IDS: Record<LanguageCode, string> = {
  de: 'de-DE',
  fr: 'fr-CH',
  it: 'it-CH',
};

/** Locale of the date pickers (date-fns adapter). */
export const DATE_LOCALES: Record<LanguageCode, Locale> = { de, fr, it };
